import getApi from '../../../api'
import { OrganizationInterop } from '../../../model/OrganizationInterop'

export const getOrganizationInterop = (organizationCode: string, signal?: AbortSignal) =>
  getApi().get<OrganizationInterop>(
    `/admin/interop/organizations/${organizationCode}`,
    {},
    { signal },
  )
